__turbopack_context__.v({
  "articleDate": "OSC4UG_articleDate",
  "articleFigure": "OSC4UG_articleFigure",
  "articleHeading": "OSC4UG_articleHeading",
  "articleImage": "OSC4UG_articleImage",
  "content": "OSC4UG_content",
  "grow": "OSC4UG_grow",
  "readProgress": "OSC4UG_readProgress",
  "root": "OSC4UG_root",
});
